<template>
  <div class="d-flex align-center">
    <img v-if="activeIcon" :src="activeIcon" class="phone-number__icon" />
    <a :href="`tel:${value}`" class="link">
      {{ formatPhoneNumber(value) || value }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { countries } from '@/core/consts/locale';
import { phoneMasks } from '@/core/consts/masks';
import { formatPhoneNumber } from '@/core/utils/string';

const props = defineProps<{
  value: string;
}>();

const activeIcon = computed(() => {
  const countryIndex = Object.values(phoneMasks).findIndex((mask) => props.value.startsWith(mask.replace(/\D/g, '')));

  if (countryIndex < 0) {
    return;
  }

  const countryCode = Object.keys(phoneMasks)[countryIndex];

  return countries[countryCode].flag;
});
</script>

<style scoped lang="scss">
.phone-number {
  &__icon {
    margin-right: 8px;

    border: 1px solid $border-color-light;
  }
}
</style>
